import React from "react";
import { Box, Button, Container, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import paths from "../../../Infrastructure/Router/paths";
import { styles } from "./styles";

const HeroSection = () => {
  const navigate = useNavigate();

  const scrollToFeatures = () => {
    document
      .getElementById("platform-features")
      ?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <Box sx={styles.heroSection}>
      <Container maxWidth="md">
        <Stack spacing={{ xs: 3, md: 4 }} alignItems="center" textAlign="center">
          <Typography sx={styles.heroEyebrow}>
            For Academies, Bootcamps & Training Providers
          </Typography>
          <Typography variant="h1" sx={styles.heroHeadline}>
            Your Classes. Your Brand. The Ultimate Learning Platform.
          </Typography>
          <Typography sx={styles.heroSubtext}>
            The Vulcan Learning Platform gives your organization everything it
            needs to offer live group classes online, plug and play.
          </Typography>
          <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
            <Button
              variant="contained"
              sx={styles.primaryButton}
              onClick={() => navigate(paths.contactPage.path)}
            >
              Book a Demo
            </Button>
            <Button
              variant="outlined"
              sx={styles.secondaryButton}
              onClick={scrollToFeatures}
            >
              Explore the Platform
            </Button>
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
};

export default HeroSection;
